import React from 'react';
import classNames from 'classnames';
import { ConnectedDynpackManager } from './DynpackManager';
import { SlideGroupContextProvider } from '../../components/SlideManager';
import { ConnectedSegmentManagerRoundTrip } from '../FlightsManager/Segment/SegmentManager/SegmentManagerRoundTripMobile';
import { SearchButtonStyled } from '../SearchButton';
import { ResidentDiscount } from '../ResidentDiscount/ResidentDiscountMobile';
import { ConnectedSeparateStayCheckbox, SeparateStayDateFieldMobile } from '../SeparateStay';
import { ABUtils, CMS } from '../../utils';
import { DP_SEARCH_FORM, withTrackComponentDisplayed } from '../../utils/HtmlEvents';

const labelColor = '#4C4C4C';

export const DynpackManagerMobile = withTrackComponentDisplayed(() => {
    const { isAbTrain, isCssVariationMobile } = ABUtils.getABs();
    const wrapperClassNames = classNames({
        'odf-space-inner-left-m odf-space-inner-right-m': !isCssVariationMobile,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
        'odf-space-inner-top-m odf-bg-base': true,
        'od-flights-manager-wrapper': true
    });
    return (
        <ConnectedDynpackManager render={() => (
            <>
                <div className={wrapperClassNames}>
                    <SlideGroupContextProvider>
                        <ConnectedSegmentManagerRoundTrip />
                        <ConnectedSeparateStayCheckbox labelColor={labelColor} />
                        <SeparateStayDateFieldMobile />
                    </SlideGroupContextProvider>

                    <ResidentDiscount />

                    <div className="odf-space-outer-top-m">
                        <SearchButtonStyled block dynPack>
                            { isAbTrain ? <CMS id="flightsManager.searchDynpack.TRAINS" /> : <CMS id="flightsManager.searchDynpack.main" /> }
                        </SearchButtonStyled>
                    </div>
                </div>
            </>
        )}
        />
    );
}, DP_SEARCH_FORM);
